<template>
  <div class="app-container">
    <div class="ip-title">IP 黑名单管理</div>
    <!-- 顶部工具栏 -->
    <div class="ip-toolbar">
      <el-input v-model="keyword" class="ip-search" placeholder="搜索 IP" clearable @keyup.enter.native="handleSearch" @clear="handleSearch">
        <i slot="prefix" class="el-input__icon el-icon-search" />
      </el-input>
      <el-button @click="handleSearch">搜索</el-button>
      <el-button type="primary" @click="openAdd"><i class="el-icon-plus"></i> 手动封禁</el-button>
    </div>

    <!-- 列表 -->
    <el-table :data="data" v-loading="loading" border style="width:100%">
      <el-table-column prop="ip" label="IP" width="180" />
      <el-table-column label="类型" width="100" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type === 0 ? 'primary' : 'danger'" size="small">{{ scope.row.type === 0 ? '手动' : '自动' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="原因" min-width="160" show-overflow-tooltip />
      <el-table-column label="到期时间" width="180">
        <template slot-scope="scope">{{ scope.row.expireTime || '永久' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="建立时间" width="180" />
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleRemove(scope.row)">解封</el-button>
        </template>
      </el-table-column>
      <template slot="empty">暂无封禁记录</template>
    </el-table>
    <el-pagination
      class="ip-pagination"
      layout="total, prev, pager, next"
      :current-page="page"
      :page-size="pageSize"
      :total="total"
      @current-change="onPageChange"
    />

    <!-- 手动封禁弹窗 -->
    <el-dialog title="手动封禁 IP" :visible.sync="addOpen" width="480px" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-form-item label="IP 地址" prop="ip">
          <el-input v-model="form.ip" placeholder="例如 192.168.1.100" />
        </el-form-item>
        <el-form-item label="封禁原因" prop="reason">
          <el-input v-model="form.reason" type="textarea" :rows="2" placeholder="可选" />
        </el-form-item>
        <el-form-item label="封禁时长" prop="expireHours">
          <el-select v-model="form.expireHours" class="full-width" placeholder="选择时长" clearable>
            <el-option label="1 小时" :value="1" />
            <el-option label="6 小时" :value="6" />
            <el-option label="24 小时" :value="24" />
            <el-option label="3 天" :value="72" />
            <el-option label="7 天" :value="168" />
            <el-option label="30 天" :value="720" />
            <el-option label="永久" :value="undefined" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addOpen = false">取消</el-button>
        <el-button type="primary" @click="handleAdd">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listIpBlacklist, addIpBlacklist, removeIpBlacklist } from '@/api/customerService/ipBlacklist'

export default {
  name: 'CustomerServiceIpBlacklistList',
  data() {
    return {
      data: [],
      total: 0,
      page: 1,
      pageSize: 20,
      keyword: '',
      loading: false,
      addOpen: false,
      form: {
        ip: '',
        reason: '',
        expireHours: undefined
      },
      rules: {
        ip: [{ required: true, message: '请输入 IP', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(p, kw) {
      const page = p !== undefined ? p : this.page
      const keyword = kw !== undefined ? kw : this.keyword
      this.loading = true
      listIpBlacklist({ page: page, size: this.pageSize, keyword: keyword || undefined }).then(res => {
        if (res.code === 0) {
          this.data = res.result.records || []
          const rawTotal = res.result && res.result.total
          this.total = Number(rawTotal) > 0 ? Number(rawTotal) : 0
        }
      }).catch(() => {
        this.$message.error('加载失败')
      }).finally(() => { this.loading = false })
    },
    handleSearch() {
      this.page = 1
      this.fetchData(1, this.keyword)
    },
    onPageChange(p) {
      this.page = p
      this.fetchData(p)
    },
    openAdd() {
      this.addOpen = true
    },
    resetForm() {
      this.form.ip = ''
      this.form.reason = ''
      this.form.expireHours = undefined
    },
    handleAdd() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        addIpBlacklist({
          ip: this.form.ip,
          reason: this.form.reason || undefined,
          expireHours: this.form.expireHours
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('添加成功')
            this.addOpen = false
            this.resetForm()
            this.fetchData()
          }
        })
      })
    },
    handleRemove(record) {
      this.$confirm('确定要解封 IP ' + record.ip + ' 吗？', '确认解封', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeIpBlacklist(record.id).then(res => {
          if (res.code === 0) {
            this.$message.success('已解封')
            this.fetchData()
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.ip-title { font-size: 20px; font-weight: 600; margin: 0 0 16px; }
.ip-toolbar { display: flex; gap: 8px; margin-bottom: 16px; }
.ip-search { width: 220px; }
.ip-pagination { margin-top: 16px; text-align: right; }
.full-width { width: 100%; }
</style>